import {
    SET_LANGUAGE
} from "../mutations/localization";
import i18n from "../../localization";

const localization = {
    namespaced: true,
    state: {
        initialized: false,
        language: i18n.locale, //loading iniziale
    },
    mutations: {
        [SET_LANGUAGE](state, payload) {
            state.language = payload.language;
            state.initialized = payload.initialized;
        }
    },
    actions: {
        setLanguage({commit, state}, language) {
            i18n.locale = language;
            commit({
                type: SET_LANGUAGE,
                language,
                initialized: true,
            })
        },
    }

};

export default localization;
